import { useContext, useEffect } from "react";
import swal from "sweetalert";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";

import { GlobalContext } from "../Context/GlobalState";

const clientId =
  "1080941448325-li5qeour49efnj34a0tl16q8fcrkdk7t.apps.googleusercontent.com";
const scriptUrl = "https://accounts.google.com/gsi/client";

const GoogleOneTapLogin = () => {
  const { setUserData } = useContext(GlobalContext);

  useEffect(() => {
    let active = true;
    let initialized = false;
    let submitting = false;
    let completed = false;

    const handleCredentialResponse = async (response) => {
      if (!active || submitting || completed) return;
      if (typeof response?.credential !== "string" || !response.credential.trim()) {
        swal("Google sign-in failed", "Google did not return a credential. Please try again.", "error");
        return;
      }
      submitting = true;
      try {
        const res = await fetch(
          `${BASE_URL_API_TRANXT_UAT_API}/api/GoogleAuth/google-one-tap`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ credential: response.credential }),
          }
        );
        if (!res.ok) throw new Error("Google sign-in request failed");
        const data = await res.json();
        if (data.responseCode !== "00" || !data.response?.googleId || !data.response?.email) {
          throw new Error("Google sign-in was not successful");
        }
        if (!active) return;
        const profile = data.response;
        const user = {
          googleId: profile.googleId,
          email: profile.email,
          emailVerified: profile.emailVerified === true,
          name: profile.name || [profile.firstName, profile.lastName].filter(Boolean).join(" "),
          firstName: profile.firstName || "",
          lastName: profile.lastName || "",
          picture: profile.picture || "",
        };
        // Keep the profile available after reload; never store the Google credential.
        try {
          localStorage.setItem("googleUser", JSON.stringify(user));
        } catch {
          // Sign-in still works for this page when storage is unavailable.
        }
        completed = true;
        setUserData(user);
      } catch {
        if (active) {
          swal("Google sign-in failed", "We could not complete Google sign-in. Please try again.", "error");
        }
      } finally {
        submitting = false;
      }
    };

    const startOneTap = () => {
      if (!active || initialized || !window.google?.accounts?.id) return;
      initialized = true;
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
        use_fedcm_for_prompt: true,
      });
      window.google.accounts.id.prompt();
    };

    let script = document.querySelector(`script[src="${scriptUrl}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
    script.addEventListener("load", startOneTap);
    startOneTap();

    return () => {
      active = false;
      script.removeEventListener("load", startOneTap);
      if (initialized) window.google?.accounts?.id?.cancel();
    };
  }, [setUserData]);

  return null;
};

export default GoogleOneTapLogin;
